// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isWednesday/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isWednesday = convertToFP(fn, 1);
export default isWednesday;